import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const rewardTargetsRoutes = [
	{
		key: "reward-targets",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/targets`,
		component: React.lazy(() => import("views/reward-views/targets/pages/TargetsList")),
	},
];
